if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const prevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg width="70" height="70" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1"><path vector-effect="non-scaling-stroke" d="M 30 25 L 20 35 L 30 45 M 20 35 H 50" /><circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" /><circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <span>Next</span>
        <svg width="70" height="70" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1"><path vector-effect="non-scaling-stroke" d="M 40 25 L 50 35 L 40 45 M 50 35 H 20" /><circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" /><circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" /></svg>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // HOME WRAP DINING + REVIEWS
    if ( document.querySelector('.diningModule') ) {
        const diningModule = document.querySelector('.diningModule');
        const dining_reviews_together = diningModule.nextElementSibling.classList.contains('reviewsModule');
        if ( dining_reviews_together ) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('diningReviewsWrapper');
            diningModule.insertAdjacentElement('beforebegin', wrapper);
            wrapper.appendChild( diningModule );
            wrapper.appendChild( document.querySelector('.reviewsModule') );
        }
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick( slickOptions );

    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });

})();